import {BOOKING_STATUSES} from "./constant";
import React from "react";
import {staticImages} from "../../assets/images";
import {styled} from "@mui/material";

const CarSection = ({status, isDarkMode}) => {
    const imageHeight = 314;
    return (<>
        {status === BOOKING_STATUSES.READY && <>
            <StyledGifImage
                src={isDarkMode ? staticImages.clientCarParkedDarkGif : staticImages.clientCarParkedLightGif}
                height={imageHeight}/>
        </>}
        {status === BOOKING_STATUSES.BOOKED && <>
            <StyledGifBooked
                src={isDarkMode ? staticImages.clientCarBookedDarkGif : staticImages.clientCarBookedLightGif}
                height={imageHeight}/>
        </>}
        {(status !== BOOKING_STATUSES.READY) && (status !== BOOKING_STATUSES.BOOKED) && <>
            <StyledImage
                src={isDarkMode ? staticImages.clientCarLightsOnDark : staticImages.clientCarLightsOnLight}
                height={imageHeight}
            />
        </>}
    </>)
}

export default CarSection

const StyledImage = styled('img')(
    () => `
      width: auto;
      object-fit: cover;
      margin-top: 30px;
      `
)

const StyledGifBooked = styled('img')(
    () => `
      width: auto;
      object-fit: cover;
      `
);

const StyledGifImage = styled('img')(
    () => `
      width: auto;
      object-fit: cover;
      margin-bottom: 30px;
      `
);